import { WordFragment } from "../create";
import { footerXml, headerXml } from "../structure";
import { CreateElement } from "./element";

interface OptionsReference {
    /** Replace existing reference in the section. Default as true */
    replaceOthers?: boolean;
    /** Section to add the content. Default as -1 (last section) */
    section?: number | "all";
    /** Content */
    text: WordFragment;
    /** Type. Default as default */
    type?: "default" | "even" | "first";
}

type Reference = "footer" | "header";

/**
 * Create reference
 */
class CreateReference extends CreateElement {
    /**
     * Element options
     */
    protected options: OptionsReference;

    /**
     * Target
     */
    protected target: "footer" | "header";

    /**
     * Constructor
     *
     * @param options - Options reference
     * @param target - Reference target
     */
    constructor(options: OptionsReference, target: Reference) {
        super();

        // default options
        options.replaceOthers ??= true;
        options.section ??= -1;
        options.type ??= "default";

        this.options = options;
        this.target = target;
    }

    /**
     * Getter options
     *
     * @returns Reference options
     */
    public getOptions(): OptionsReference {
        return this.options;
    }

    /**
     * Getter target
     *
     * @returns Target
     */
    public getTarget(): Reference {
        return this.target;
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        let contents = "";

        if (this.target == "footer") {
            contents = footerXml.replace(
                "</w:ftr>",
                this.options.text.toString() + "</w:ftr>"
            );
        } else if (this.target == "header") {
            contents = headerXml.replace(
                "</w:hdr>",
                this.options.text.toString() + "</w:hdr>"
            );
        }

        return contents;
    }
}

export { CreateReference, OptionsReference, Reference };
